// Translation: German > Format
const format = Object.freeze({
	parantheses: '({{reference}})',
	range: '{{low}}–{{high}}',
	ratio: '{{primary}}/{{secondary}}',
	threeDots: '{{reference}}...'
})

// Export
export default format
